export const NEW_HOME_PAGE_EXPERIMENT_COOKIE_KEY = '_page_ab_new_home_page'
